/*
export default {
  presets: {
    light: {
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
    },
    dark: {
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  }
    
}
*/
export const SpreadColors = {
  presets: {
    light: {
      primary: '#191825', // New primary color for the light theme
      secondary: '#999', // New secondary color for the light theme
      authBackground: '#191825', // New primary color for the light theme
    },
    dark: {
      primary: '#fff', // New primary color for the dark theme
      secondary: '#ccc', // New secondary color for the dark theme
      backgroundPrimary: '#111111', // New primary background color for the dark theme
      backgroundSecondary: '#191825', // blauw achtergrond spread logo
      authBackground: '#191825', // New primary color for the dark theme
      backgroundCardPrimary: '#2b2a3dff',
      backgroundCardSecondary: '#191825',
    },
  },
}
